export default __webpack_public_path__ + "static/media/upee_girl_b.20005f32.webp";